import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { TimesheetCalendarSourceType } from 'api/timesheets';
import { Configuration } from 'api/timesheets/configuration/configuration';
import { ReactComponent as AtomGCalLogo } from 'assets/svgs/google-calendar.svg';
import { ReactComponent as AtomOutlookCal } from 'assets/svgs/outlook.svg';
import { GoogleLogin, MicrosoftLogin } from 'components/atoms/vendor-loign';
import { useTimesheetIntegrationOauthQuery } from 'queries/timesheets/calendar-integration-provider';
import { Drawer, DrawerBody, EmptyState } from '../component';
import { getSourceTypeFromTimesheetConfig } from '../util';

interface Props {
  onClose: () => void;
  visible: boolean;
  configuration: Configuration;
}
const GCalLogo = styled(AtomGCalLogo)`
  width: 60px;
  height: 60px;
`;
const OutlookCal = styled(AtomOutlookCal)`
  width: 60px;
  height: 60px;
`;

export const SetupCalendar: FC<Props> = ({
  onClose,
  visible,
  configuration,
}) => {
  const sourceType = getSourceTypeFromTimesheetConfig(configuration);
  const { data: authMeta, isLoading } =
    useTimesheetIntegrationOauthQuery(sourceType);
  const googleOAuth = authMeta?.oauthUrl;

  const isGcal = sourceType === TimesheetCalendarSourceType.GoogleCalendar;
  const LoginButton = isGcal ? GoogleLogin : MicrosoftLogin;

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      destroyOnClose
      title={<FormattedMessage id="timesheets.integration.drawer.title" />}
    >
      <DrawerBody>
        <EmptyState
          image={isGcal ? <GCalLogo /> : <OutlookCal />}
          title={
            <FormattedMessage id="timesheets.calendar-integration.title" />
          }
          message={
            isGcal ? (
              <FormattedMessage id="timesheets.integration_google.message" />
            ) : (
              <FormattedMessage id="timesheets.integration_microsoft.message" />
            )
          }
          primaryCTA={<LoginButton href={googleOAuth!} isLoading={isLoading} />}
        />
      </DrawerBody>
    </Drawer>
  );
};
